package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.radar.options.plugins.LegendLabelOptions

@RadarDsl
class LegendLabelScope {
    private var color: JSScriptable<ChartColor>? = null
    private var fontScope: FontScope? = null
    var boxWidth: Int? = null
    var boxHeight: Int? = null
    var padding: Int? = null
    var usePointStyle: Boolean = false
    var pointStyleWidth: Float? = null

    fun color(value: ChartColor) { color = JSScriptable.Static(value) }
    fun color(fn: (dynamic) -> ChartColor) { color = JSScriptable.Scriptable(fn) }

    fun font(block: FontScope.() -> Unit) {
        fontScope = FontScope().apply(block)
    }

    internal fun build() = LegendLabelOptions(
        color = color,
        font = fontScope?.build(),
        boxWidth = boxWidth,
        boxHeight = boxHeight,
        padding = padding,
        usePointStyle = usePointStyle,
        pointStyleWidth = pointStyleWidth,
    )
}
